import React, { Component, Context } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { WidgetProps } from "../widgets";
import { IHonorUState, mapHonorUStateToProps } from "../../redux/reducers/honoru";
import { IHonorUActionDispatches, mapHonorUDispatchToProps, getProfileUrl } from "../../redux/actions/honoru";
import { HONORU_ICON_URL } from "../../models/honoru";
import { getDateDisplay } from "../../utils/date-utils";
import LayoutContext, { ILayoutContext } from "../../contexts/layout/LayoutContext";
import ImageEnlarge from "../ui/Media/ImageEnlarge";
import { UITextBlock } from "../ui/UITextBlock";
import "./HonorU.scss";

class HonorUFeatured extends Component<IHonorUActionDispatches & IHonorUState & WidgetProps, any> {
	static contextType: Context<ILayoutContext> = LayoutContext;

	componentDidMount() {
		this.props.loadFeaturedProfileAndLandingPageData();
	}

	render() {
		return (
			<div className="w-100 position-relative">
				<div
					className={clsx(
						!this.props.isNested && "container",
						!this.props.page?.noPadding && "section-padding"
					)}
				>
					<div className="row">
						<div className="col-12 col-md-5 d-flex align-items-center mb-3">
							<UITextBlock
								title={`${this.props.isNested ? "" : "About "}HonorU`}
								desc={this.props.landingHeadline}
								link={{
									url: "https://honoru.co/",
									display: "Visit HonorU Website",
								}}
								iconUrl={HONORU_ICON_URL}
							/>
						</div>
						<div className="d-none d-md-block col-md-1" />
						<div className="col-12 col-md-6 honoru-landing">
							{!!this.props.landingMedia && (
								<ImageEnlarge image={this.props.landingMedia} height={this.props.landingMedia.height}>
									{!!this.props.landingProfile && (
										<div
											className="position-absolute bg-white-opac py-3 px-4 pl-4_5"
											style={{ bottom: "-4px", left: "-1px" }}
										>
											<div className="text-gray text-uppercase text-sm mb-1">
												{!!this.props.landingProfile.from &&
													getDateDisplay(
														this.props.landingProfile.from,
														this.props.landingProfile.to,
														" - ",
														true,
														true
													)}
											</div>
											<a
												href={`https://honoru.co/profile/${this.props.landingProfile.id}/`}
												target="_blank"
												className="mb-3"
											>
												{this.props.landingProfile.name}
											</a>
										</div>
									)}
								</ImageEnlarge>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect<IHonorUState, IHonorUActionDispatches, WidgetProps>(
	mapHonorUStateToProps,
	mapHonorUDispatchToProps
)(HonorUFeatured);
